export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';

// Get All Alerts
export const GET_ALERTS_START = 'GET_ALERTS_START';
export const GET_ALERTS_SUCCESS = 'GET_ALERTS_SUCCESS';
export const GET_ALERTS_FAIL = 'GET_ALERTS_FAIL';

// Get Alert By ID
export const GET_ALERT_BY_ID_START = 'GET_ALERT_BY_ID_START';
export const GET_ALERT_BY_ID_SUCCESS = 'GET_ALERT_BY_ID_SUCCESS';
export const GET_ALERT_BY_ID_FAIL = 'GET_ALERT_BY_ID_FAIL';

// Get Alert By Name
export const GET_ALERT_BY_NAME_START = 'GET_ALERT_BY_NAME_START';
export const GET_ALERT_BY_NAME_SUCCESS = 'GET_ALERT_BY_NAME_SUCCESS';
export const GET_ALERT_BY_NAME_FAIL = 'GET_ALERT_BY_NAME_FAIL';

// Create Alert
export const CREATE_ALERT_START = 'CREATE_ALERT_START';
export const CREATE_ALERT_SUCCESS = 'CREATE_ALERT_SUCCESS';
export const CREATE_ALERT_FAIL = 'CREATE_ALERT_FAIL';

// Update Alert
export const UPDATE_ALERT_START = 'UPDATE_ALERT_START';
export const UPDATE_ALERT_SUCCESS = 'UPDATE_ALERT_SUCCESS';
export const UPDATE_ALERT_FAIL = 'UPDATE_ALERT_FAIL';

// Delete Alert
export const DELETE_ALERT_START = 'DELETE_ALERT_START';
export const DELETE_ALERT_SUCCESS = 'DELETE_ALERT_SUCCESS';
export const DELETE_ALERT_FAIL = 'DELETE_ALERT_FAIL';

// Execute Alerts
export const EXECUTE_ALERTS_START = 'EXECUTE_ALERTS_START';
export const EXECUTE_ALERTS_SUCCESS = 'EXECUTE_ALERTS_SUCCESS';
export const EXECUTE_ALERTS_FAIL = 'EXECUTE_ALERTS_FAIL';

// Get Attribute Values
export const GET_ATTRIBUTE_VALUES_START = 'GET_ATTRIBUTE_VALUES_START';
export const GET_ATTRIBUTE_VALUES_SUCCESS = 'GET_ATTRIBUTE_VALUES_SUCCESS';
export const GET_ATTRIBUTE_VALUES_FAIL = 'GET_ATTRIBUTE_VALUES_FAIL';

// Get Alerts List (from SQL workbench)
export const GET_ALERTS_LIST_START = 'GET_ALERTS_LIST_START';
export const GET_ALERTS_LIST_SUCCESS = 'GET_ALERTS_LIST_SUCCESS';
export const GET_ALERTS_LIST_FAIL = 'GET_ALERTS_LIST_FAIL';

